/** @jsxImportSource theme-ui */
import { darken } from '@theme-ui/color'
import { Box } from 'theme-ui'
import React, { createContext, useContext, useState } from 'react'
import { scaleDown as Menu } from 'react-burger-menu'
import {
  FaArchive,
  FaHome,
  FaPlusCircle,
  FaQuestionCircle,
  FaSignInAlt,
  FaSignOutAlt,
} from 'react-icons/fa'
import { GiHamburgerMenu } from 'react-icons/gi'
import { useNavigate } from 'react-router-dom'
import useCurrentUserStore, {
  getUserToken,
  removeUserToken,
} from '../../stores/currentUser'
import colors from '../../theme/colors'
import { notifySuccess } from '../Notif'

const SidebarMenuContext = createContext(null)

export default function SidebarMenu() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <SidebarMenuContext.Provider
      value={{
        isOpen,
        toggle: () => setIsOpen(!isOpen),
        onStateChange: (state) => setIsOpen(state.isOpen),
      }}
    >
      <Navigation />
    </SidebarMenuContext.Provider>
  )
}

function Navigation(props: any) {
  const userToken = getUserToken()
  const { removeCurrentUser } = useCurrentUserStore()
  const { isOpen, toggle, onStateChange } = useContext(SidebarMenuContext)
  const navigate = useNavigate()

  function logout() {
    removeUserToken()
    removeCurrentUser()
    notifySuccess('Logout successfull')
  }

  const closeAndNavigate = (to) => () => {
    toggle()
    navigate(to)
  }

  return (
    <Menu
      right
      {...props}
      isOpen={isOpen}
      styles={sidebarStyles}
      customBurgerIcon={<GiHamburgerMenu role="button" onClick={toggle} />}
      onStateChange={onStateChange}
    >
      <Box className="menu-item" onClick={closeAndNavigate('/')}>
        <FaHome style={{ marginRight: '10px' }} />
        <span>Home</span>
      </Box>
      <Box
        className="menu-item"
        onClick={closeAndNavigate('/laporan-pengaduan/create')}
      >
        <FaPlusCircle style={{ marginRight: '10px' }} />
        Create Report
      </Box>
      <Box
        className="menu-item"
        onClick={closeAndNavigate('/laporan-pengaduan/archived')}
      >
        <FaArchive style={{ marginRight: '10px' }} />
        Archive Reports
      </Box>
      <Box className="menu-item" onClick={closeAndNavigate('/faq')}>
        <FaQuestionCircle style={{ marginRight: '10px' }} />
        FAQ
      </Box>
      <Box
        className="menu-item"
        onClick={() => {
          if (userToken) logout()
          toggle()
          navigate('/login')
        }}
      >
        {userToken ? (
          <FaSignOutAlt style={{ marginRight: '10px' }} />
        ) : (
          <FaSignInAlt style={{ marginRight: '10px' }} />
        )}
        {userToken ? 'Logout' : 'Login'}
      </Box>
    </Menu>
  )
}

export const sidebarStyles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    top: '15px',
    right: '15px',
    float: 'right',
    color: colors.white,
  },
  bmBurgerBars: {
    background: colors.secondary,
  },
  bmBurgerBarsHover: {
    background: colors.white,
  },
  bmCrossButton: {
    height: '24px',
    width: '24px',
  },
  bmCross: {
    background: colors.white,
  },
  bmMenuWrap: {
    position: 'fixed',
    top: '0',
    right: '0px',
    zIndex: '1100',
    width: '300px',
    height: '100%',
    transition: 'all 0.5s ease 0s',
  },
  bmMenu: {
    background: colors.primary,
    padding: '2.5em 1.5em 0',
    fontSize: '1.15em',
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'auto',
    '&:hover': {
      color: darken(colors.primary, 0.1),
    },
  },
  bmMorphShape: {
    fill: 'green',
  },
  bmItemList: {
    color: colors.white,
    padding: '0.8em',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  /* Individual item */
  bmItem: {
    display: 'inline-block',
    color: colors.white,
    marginBottom: '30px',
    textAlign: 'left',
    textDecoration: 'none',
    transition: 'color 0.2s',
  },
  bmItemHover: {
    color: colors.secondary,
  },
  bmMenuHover: {
    color: darken(colors.primary, 0.1),
  },
  bmMenuFocus: {
    color: darken(colors.primary, 0.2),
  },
  bmOverlay: {
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: '1000',
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.3)',
    opacity: '1',
    transition: 'opacity 0.3s ease 0s',
  },
}
